import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const PreferencesNotification = ({ show, onDismiss, message }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/profile');
    onDismiss(); // Dismiss the notification when navigating
  };

  if (!show) return null;

  return (
    <Alert 
      variant="secondary" 
      className="preferences-notification"
      style={{
        position: 'fixed',
        top: '140px', // Position below both availability and friends notifications
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1048, // Lower z-index than other notifications
        maxWidth: '500px',
        width: '90%',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        border: 'none',
        borderRadius: '8px'
      }}
    >
      <div className="d-flex align-items-center justify-content-between">
        <div className="flex-grow-1">
          <Alert.Heading className="mb-1" style={{ fontSize: '1rem' }}>
            <i className="fas fa-heart me-2"></i>
            No Activity Preferences
          </Alert.Heading>
          <p className="mb-0" style={{ fontSize: '0.9rem' }}>
            {message}
          </p>
        </div>
        <div className="ms-3">
          <Button 
            variant="outline-secondary" 
            size="sm"
            onClick={handleClick}
            style={{ 
              borderColor: '#6c757d',
              color: '#495057',
              fontWeight: 'bold'
            }}
          >
            Set Preferences
          </Button>
          <Button 
            variant="link" 
            size="sm"
            onClick={onDismiss}
            style={{ 
              color: '#495057',
              textDecoration: 'none',
              padding: '0.25rem 0.5rem'
            }}
          >
            <i className="fas fa-times"></i>
          </Button>
        </div>
      </div>
    </Alert>
  );
};

export default PreferencesNotification;
